// extracted by mini-css-extract-plugin
export var avatarContainer = "_h0-0";
export var avatarTypingWave = "_h0-i";
export var gray = "_h0-f";
export var green = "_h0-c";
export var icon = "_h0-9";
export var image = "_h0-1";
export var lg = "_h0-6";
export var md = "_h0-5";
export var presenceDot = "_h0-b";
export var red = "_h0-d";
export var sm = "_h0-4";
export var status = "_h0-a";
export var typingDot = "_h0-h";
export var typingPill = "_h0-g";
export var xl = "_h0-7";
export var xs = "_h0-3";
export var xxl = "_h0-8";
export var xxs = "_h0-2";
export var yellow = "_h0-e";